<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      mobile-breakpoint="0"
    >
      <template v-slot:body="{ items }">
        <tr
          v-for="(item, col_index) in items"
          :key="`col${col_index}`"
          class=" mt-3 mb-5"
        >
          <td>
            <div class="py-3">
              <p class="text-wrap">
                {{ item.projectName }}
              </p>
            </div>

            <div v-if="!item.isEditData">
              <v-chip class="mb-2 mt-n5" color="primary" small>
                เพิ่มโดยเจ้าหน้าที่
              </v-chip>
            </div>
          </td>
          <td>
            <div>
              {{ $dateFormatByLang(item.beginDate) }}
            </div>
          </td>
          <td>
            <div>
              {{ $dateFormatByLang(item.endDate) }}
            </div>
          </td>
          <!-- <td>
            <div>
              {{ item.trainingAtionTypeName }}
            </div>
          </td> -->
          <td>
            <v-row justify="center" class="mt-1">
              <!-- {{ item.actionEmptraining }} -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="mr-1 mb-1"
                    color="warning"
                    :disabled="!item.isEditData"
                    @click="editBtn(item.trainingNumber)"
                    ><v-icon>mdi-pencil</v-icon></v-btn
                  >
                </template>
                <span>แก้ไข</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="mr-1 mb-1"
                    color="error"
                    :disabled="!item.isEditData"
                    @click="delBtn(item.trainingNumber)"
                    ><v-icon>mdi-trash-can-outline</v-icon></v-btn
                  >
                </template>
                <span>ลบ</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="mr-1 mb-1"
                    color="primary"
                    @click="detailBtn(item.trainingNumber)"
                    ><v-icon>mdi-dots-horizontal-circle-outline</v-icon></v-btn
                  >
                </template>
                <span>ดูเพิ่มเติม</span>
              </v-tooltip>
            </v-row>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    headers: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    delBtn(trainingNumber) {
      this.$emit('delBtn', trainingNumber)
      //console.log('sdasd0 ' + trainingNumber)
    },
    detailBtn(trainingNumber) {
      this.$emit('detailBtn', trainingNumber)
      //console.log('sdasd0 ' + trainingNumber)
    },
    editBtn(trainingNumber) {
      this.$emit('editBtn', trainingNumber)
      //console.log('sdasd0 ' + trainingNumber)
    }
  }
}
</script>

<style lang="scss" scoped>
// .name {
//   max-width: 300px;
// }
// td {
//   width: 150px;
//   border: 1px solid #000000;
// }
// td .textWarp {
//   word-wrap: break-word;
// }
table td {
  border-bottom: 1px solid #dddddd;
}
</style>
